import { Combobox } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';

type MultiSelectFilterProps = {
  options: { id: number; label: string }[];
  value: number[];
  onChange: (ids: number[]) => void;
  /** Injetado pelo `FormField`. */
  id?: string;
};

/** Seleção múltipla sobre listas curtas já carregadas; nada marcado = "Todos". */
export function MultiSelectFilter({ options, value, onChange, id }: MultiSelectFilterProps) {
  const { t } = useTranslation('alocacao');
  return (
    <Combobox
      id={id}
      multiple
      value={value.map(String)}
      onValueChange={(values) => onChange(values.map(Number))}
      placeholder={t('consultas.filtros.todos')}
      valueLabels={Object.fromEntries(options.map((option) => [String(option.id), option.label]))}
    >
      <Combobox.Trigger
        removeLabel={(label) => t('filtros.chips.remover', { filter: String(label) })}
      />
      <Combobox.Content withSearchInput={options.length > 8}>
        {options.map((option) => (
          <Combobox.Option key={option.id} value={String(option.id)}>
            {option.label}
          </Combobox.Option>
        ))}
      </Combobox.Content>
    </Combobox>
  );
}
